export default class BlockActivityDetails {
    constructor(container, options) {
        const defaultOptions = {
            isSwiperActive: true,
            swiperElement: '.swiper',
            swiperPagination: '.swiper-pagination',
            swiperPaginationNext: '.swiper-button-next',
            swiperPaginationPrevious: '.swiper-button-prev',
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.swiperElem = this.container.querySelector(this.options.swiperElement);
        this.swiperPagination = this.container.querySelector(this.options.swiperPagination);
        this.swiperPaginationNext = this.container.querySelector(this.options.swiperPaginationNext);
        this.swiperPaginationPrevious = this.container.querySelector(this.options.swiperPaginationPrevious);
        this.isSwiperActive = this.options.isSwiperActive;

        this.swiper = null;

        if(this.isSwiperActive)
            this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperElem, {
            direction: 'horizontal',
            loop: false,
            grabCursor: true,
            slidesPerView: 1.15,
            centeredSlides: true,
            initialSlide: 0,
            spaceBetween: 15,
            pagination: {
                el: this.swiperPagination,
                clickable: true
            },
            navigation: {
                nextEl: this.swiperPaginationNext,
                prevEl: this.swiperPaginationPrevious,
            },
            breakpoints: {
                998: {
                    slidesPerView: 3.15,
                    centeredSlides: false,
                    spaceBetween: 30
                },
                1200: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30
                }
            }
        })
    }
}